export interface IconOptions {
  /** CSS class to add to the SVG element */
  className?: string;
  /** Width/height in pixels, defaults to 24 */
  size?: number;
}

function svgWrapper(paths: string, opts?: IconOptions): string {
  const cls = opts?.className ? ` class="${opts.className}"` : '';
  const size = opts?.size ?? 24;
  return `<svg${cls} xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
}

/** 水滴 */
export function iconWaterDrop(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 2C12 2 6 10 6 14a6 6 0 0 0 12 0C18 10 12 2 12 2Z"/>', opts);
}

/** 太阳 */
export function iconSun(opts?: IconOptions): string {
  return svgWrapper('<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>', opts);
}

/** 放大镜 */
export function iconSearch(opts?: IconOptions): string {
  return svgWrapper('<circle cx="11" cy="11" r="7"/><path d="m16.5 16.5 5 5"/>', opts);
}

/** 齿轮 */
export function iconGear(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/>', opts);
}

/** 下载 */
export function iconDownload(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 3v12"/><path d="m8 11 4 4 4-4"/><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>', opts);
}

/** 上传 */
export function iconUpload(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 15V3"/><path d="m8 7 4-4 4 4"/><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>', opts);
}

/** 幼苗 */
export function iconSprout(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 20V8"/><path d="M12 14c-3-2-5-4-5-6a5 5 0 0 1 10 0c0 2-2 4-5 6"/>', opts);
}

/** 香草叶 */
export function iconLeaf(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 20V8"/><path d="M5 15a7 7 0 0 1 9.9-6.5"/><path d="M12 8a7 7 0 0 1 7 7"/>', opts);
}

/** 月亮 */
export function iconMoon(opts?: IconOptions): string {
  return svgWrapper('<path d="M20 12.79A9 9 0 1 1 11.21 4 7 7 0 0 0 20 12.79Z"/>', opts);
}

/** 星光 */
export function iconSparkle(opts?: IconOptions): string {
  return svgWrapper('<path d="M12 3l1.5 5.5L19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5L12 3Z"/>', opts);
}

/** 风中叶 */
export function iconLeafWind(opts?: IconOptions): string {
  return svgWrapper('<path d="M8 20c4 0 8-2 8-7 0-2-1-4-2-4"/><path d="M14 9a4 4 0 0 0-8 3c0 3 2 4 4 7"/><path d="M3 12h3"/><path d="M18 10h3"/>', opts);
}

/** 叉号 */
export function iconCross(opts?: IconOptions): string {
  return svgWrapper('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>', opts);
}

/** 花园 */
export function iconFlower(opts?: IconOptions): string {
  return svgWrapper('<circle cx="12" cy="9" r="3"/><path d="M12 12v9"/>', opts);
}

/** 向日葵 */
export function iconSunflower(opts?: IconOptions): string {
  return svgWrapper('<circle cx="12" cy="12" r="3"/><path d="M12 2v4"/><path d="M12 18v4"/><path d="M4.93 4.93l2.83 2.83"/><path d="M16.24 16.24l2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="M4.93 19.07l2.83-2.83"/><path d="M16.24 7.76l2.83-2.83"/>', opts);
}

/** 三片叶（植物统计） */
export function iconSproutBar(opts?: IconOptions): string {
  return svgWrapper(
    '<path d="M12 22V8"/>' +
    '<path d="M12 16c-3-3-6-3-6 0s3 3 6 0"/>' +
    '<path d="M12 12c3-3 6-3 6 0s-3 3-6 0"/>' +
    '<path d="M12 8c-2-3-4-6-2-6s5 3 2 6"/>' +
    '<path d="M12 8c2-3 4-6 2-6s-5 3-2 6"/>',
    opts
  );
}

/** 心形（健康） */
export function iconHeart(opts?: IconOptions): string {
  return svgWrapper('<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>', opts);
}

/** 趋势（金币曲线） */
export function iconTrending(opts?: IconOptions): string {
  return svgWrapper('<path d="M23 6l-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/>', opts);
}

/** 分离/弹出（detach） */
export function iconPopout(opts?: IconOptions): string {
  return svgWrapper('<path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>', opts);
}
